import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import "react-quill/dist/quill.bubble.css"; // Import Quill styles
import "./style.scss";

const QuillEditor = ({ form, fieldName, onChange, theme, readOnly, tvalue, showToolbar, toolbarOptions, isEdit, isLink }) => {
  const [editorHtml, setEditorHtml] = useState("");
  const convertToLink = (html) => {
    if (!html) return "";
  
    // Remove all tags like <p>, <br>, etc.
    const strippedText = html.replace(/<\/?[^>]+(>|$)/g, "").trim();
  
    if (!strippedText || strippedText === "about:blank") return "";
  
    const isValidURL = /^(https?:\/\/)?([\w\d-]+\.)+\w{2,}(\/\S*)?$/.test(strippedText);
    if (!isValidURL) return strippedText;
  
    const prefixedUrl = strippedText.toLowerCase().startsWith("http")
      ? strippedText
      : `http://${strippedText}`;
  
    return `<a href="${prefixedUrl}" target="_blank" rel="noopener noreferrer">${strippedText}</a>`;
  };
  
  
  
  
useEffect(() => {
  let value = tvalue || form?.getFieldValue(fieldName) || "";

  const hasHTML = /<\/?[a-z][\s\S]*>/i.test(value);
  if (hasHTML) {
    value = value
      .replace(/\\n/g, "\n")                
      .replace(/([^>])\n/g, "$1<br />");    
  } else {
    value = value
      .replace(/\\n/g, "\n")                
      .replace(/\n{2,}/g, "<br /><br />")   
      .replace(/\n/g, "<br />");            
  }

  if (isLink) {
    setEditorHtml(convertToLink(value));
  } else {
    setEditorHtml(value);
  }
}, [tvalue, form, fieldName, isLink]);





  const handleChange = (html) => {  
    setEditorHtml(html);
    if (fieldName && form) {
      form.setFieldsValue({ [fieldName]: html });
    }
    if (onChange) {
      onChange(html);
    }
  };

  return (
    <div>
      <style jsx>{`
        .ql-toolbar .ql-formats button,
        .ql-toolbar .ql-formats .ql-picker-label,
        .ql-toolbar .ql-formats .ql-picker-item {
          font-size: 14px !important;
        }
        .ql-toolbar button svg {
          width: 16px;
          height: 16px;
        }
        .ql-tooltip {
          z-index: 1000 !important;
          left: auto !important; /* Override default left */
        }
      `}</style>
      <ReactQuill
        theme={theme}
        onChange={handleChange}
        modules={{ toolbar: toolbarOptions || (showToolbar ? QuillEditor.modules.toolbar : false) }}
        formats={QuillEditor.formats}
        value={editorHtml}
        readOnly={readOnly}
        className={isLink ? "customquillLink" : isEdit ? "customquilledit" : "customquill"}
      />
    </div>
  );
};

QuillEditor.modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    [{ font: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
    ["link", "image"],
  ],
  clipboard: {
    matchVisual: true,
  },
};

QuillEditor.formats = [
  "header", "font",
  "bold", "italic", "underline", "strike", "blockquote",
  "list", "bullet", "indent",
  "link", "image"
];

QuillEditor.propTypes = {
  form: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  theme: PropTypes.string,
  readOnly: PropTypes.bool,
  tvalue: PropTypes.string,
  showToolbar: PropTypes.bool,
  toolbarOptions: PropTypes.array,
  isEdit: PropTypes.bool,
  isLink: PropTypes.bool,
};

QuillEditor.defaultProps = {
  showToolbar: true,
};

export default QuillEditor;
